import { 
    REACH_SAVINGS_GOAL_SHOW_RESULT_SUMMARY
} from "../../../actions/savingsCalculator/whenWillYouReachYourSavingsGoal";
import { submitEarnEvent, earnEventMap } from '../rewards';
import { fireGtmEvent } from "../gtmEvents";
import {findOtherEventIndex, otherEventTracking} from '../otherEventTracking';

export const whenWillYouReachYourSavingsGoalsFieldTracking = (store, next, action) => {
    const result = next(action);
    let otherEventIndex;

    const field = (() => {
        switch (action.type){
            case REACH_SAVINGS_GOAL_SHOW_RESULT_SUMMARY: 
            otherEventIndex = findOtherEventIndex('BUTTON_CLICKED');
            submitEarnEvent(earnEventMap.savings)
                .catch(error => console.warn("submitEarnEvent failed:", error?.response?.data || error.message));
                    
            fireGtmEvent('calculator_complete', { calculator_type: 'Savings Calculator' });
            return 'when will you reach your savings goal';
        }
    })();

    if (field) {
        otherEventTracking(action.type, otherEventIndex, field);
    }

    return result;
};
